/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type BagFeaturedUpsellProductQueryVariables = Exact<{
  lineageKey: string;
  restaurantId: string;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type BagFeaturedUpsellProductQuery = {
  readonly productForRestaurantByLineageKey: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly name: string;
    readonly outOfStock: boolean;
    readonly cost: number;
  } | null;
};

export const BagFeaturedUpsellProductDocument = gql`
  query BagFeaturedUpsellProduct(
    $lineageKey: String!
    $restaurantId: String!
    $costChannel: CostChannel
  ) {
    productForRestaurantByLineageKey(lineageKey: $lineageKey, restaurantId: $restaurantId) {
      __typename
      id
      name
      outOfStock
      cost: channelCost(costChannel: $costChannel)
    }
  }
`;

export function useBagFeaturedUpsellProductQuery(
  options: Omit<Urql.UseQueryArgs<BagFeaturedUpsellProductQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagFeaturedUpsellProductQuery, BagFeaturedUpsellProductQueryVariables>({
    query: BagFeaturedUpsellProductDocument,
    ...options,
  });
}
